import React from "react";
import { createContext, useState } from "react";
import { useSelector } from "react-redux";
import { createBrowserRouter } from "react-router-dom";
import { ProtectedRouters,publicRouters } from "./router";

export const RouterContext = createContext()

export const CustomeRoutersProvider = ({ children }) => {

const { token,currentUser } = useSelector((state) => state.store);

let roleId;
let delivery_business="Ecommerce"
// console.log("RouterContext: ", currentUser?.delivery_business?.name);
if (currentUser?.delivery_business) {
  roleId = currentUser?.user_role?.role_id;
  delivery_business=currentUser?.delivery_business?.name
  console.log('delivery_business',delivery_business);  
}

let privateRouters=[]
if (token) {

privateRouters= ProtectedRouters
  
}
const router = createBrowserRouter([...publicRouters,...privateRouters]);
   

    return (
        <RouterContext.Provider
            value={{
                // Router
                router,  
                privateRouters              
            }}
        >
            {children}
        </RouterContext.Provider>
    )
}


export default RouterContext